export default __webpack_public_path__ + "b8eda22cc06973df2b22a11672410b64.svg";